export function UserCancelledAction(message = 'User cancelled action') {
    this.message = message;
    this.name = 'UserCancelledAction';
    this.ignored = true;
}

export function BackgroundJobFailed(message = 'Background job failed') {
    this.message = message;
    this.name = 'BackgroundJobFailed';
}



// WEBPACK FOOTER //
// ./resources/assets/admin/common/exceptions/index.js